import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api';

const Ctx = createContext(null);
export const useApp = () => useContext(Ctx);

const DEMO = {
  manager: 'sarah@mitchell-lettings.co.uk',
  contractor: 'james@checkaproperty.co.uk',
  admin: 'admin@checkaproperty.co.uk',
};

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem('cap_token');
    if (t) {
      api.get('/auth/me').then((r) => setUser(r.data)).catch(() => localStorage.removeItem('cap_token')).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    localStorage.setItem('cap_token', r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await api.post('/auth/register', payload);
    localStorage.setItem('cap_token', r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const quickLogin = (role) => login(DEMO[role], 'password123');

  const logout = () => { localStorage.removeItem('cap_token'); setUser(null); };

  return (
    <Ctx.Provider value={{ user, role: user?.role || null, loading, login, register, quickLogin, logout, api }}>
      {children}
    </Ctx.Provider>
  );
};
